module.exports = __webpack_public_path__ + "3b8b33f6165ca2e4900d4ef2df48ae6c.pdf";